import { IMN_THEME } from "@gemini/tokens";
import { getCookieDomain } from "@aviv-unified-frontend/internal";

import { useGoogleOneTap } from "../../../src/components/OverlayOrchestrator/overlays/GoogleOneTap/useGoogleOneTap";
import {
  ENVIRONMENT,
  STAGE_LIKE_ENVIRONMENT,
  VERSION_EPHEMERAL,
} from "../../../src/constants/environment";
import { createB2CBrand } from "../createB2CBrand";

const origin = {
  dev: "https://www.dev.immonet.de",
  preview: "https://www.preview.immonet.de",
  live: "https://www.immonet.de",
};

const consentID = {
  dev: "tgGfX8jGOFRVIz",
  preview: "dWLDa0s-m",
  live: "dWLDa0s-m",
};

const airshipConfig = {
  dev: {
    appKey: "HHmTocTNTQSK1Y0RAPfsZA",
    token:
      "MTpISG1Ub2NUTlRRU0sxWTBSQVBmc1pBOjNNRjdfQUF2d2hXQkJObUVkQ0NneEtrcUtHaVEwc0tPSV9jcTRIWUhVZDg",
    vapidPublicKey:
      "BKn_sltwQZnSnKrq8ASGSjm55aBaRdqbEONJ8T5mgDM6YDardV8Lqz6KDL5r8yndPXoYyrpqyHRwuvRw6n32e6U=",
  },
  preview: {
    appKey: "HHmTocTNTQSK1Y0RAPfsZA",
    token:
      "MTpISG1Ub2NUTlRRU0sxWTBSQVBmc1pBOjNNRjdfQUF2d2hXQkJObUVkQ0NneEtrcUtHaVEwc0tPSV9jcTRIWUhVZDg",
    vapidPublicKey:
      "BKn_sltwQZnSnKrq8ASGSjm55aBaRdqbEONJ8T5mgDM6YDardV8Lqz6KDL5r8yndPXoYyrpqyHRwuvRw6n32e6U=",
  },
  live: {
    appKey: "LMhbVNzwTFeiruyu7HNzyA",
    token:
      "MTpMTWhiVk56d1RGZWlydXl1N0hOenlBOnRieFdBbXl3SVpEX0U2cWE2QkFvR0N4Y0FtUkN2VG5ZcnkzY0VQZ1h1c3M",
    vapidPublicKey:
      "BHbziPgcNGIfNQNuJlFlS3gwgSGpqgp-9T9dfW9hGf5W8UHF9l6XsoOe9YDykzQ2rQc6SJGyzM9ZS7e2w6-wJC8=",
  },
};

const brandName = "Immonet";

const authenticationConfig = {
  dev: {
    cookies: {
      accessToken: "oauth.access.token",
      sessionExpiration: "oauth.access.se",
    },
    urls: {
      refresh: "https://dev-signin.immonet.de/refresh",
      signIn: "https://dev-signin.immonet.de/?redirect_uri=",
    },
    googleOneTap: {
      googleClientId:
        "579579693459-b2kf35gdjac2pcheh77e2ps7mr5bhial.apps.googleusercontent.com",
      auth0: {
        clientId: "M9JCT1BUhy3XNZYqrhpr7vkVlD3uYCRJ",
        audience: brandName,
      },
      useGoogleOneTap,
    },
  },
  preview: {
    cookies: {
      accessToken: "oauth.access.token",
      sessionExpiration: "oauth.access.se",
    },
    urls: {
      refresh: "https://preview-signin.immonet.de/refresh",
      signIn: "https://preview-signin.immonet.de/?redirect_uri=",
    },
    googleOneTap: {
      googleClientId:
        "579579693459-b2kf35gdjac2pcheh77e2ps7mr5bhial.apps.googleusercontent.com",
      auth0: {
        clientId: "U4Z6eGNBqd6gdxBhfOGvSTslxLcUPBzh",
        audience: brandName,
      },
      useGoogleOneTap,
    },
  },
  live: {
    cookies: {
      accessToken: "oauth.access.token",
      sessionExpiration: "oauth.access.se",
    },
    urls: {
      refresh: "https://signin.immonet.de/refresh",
      signIn: "https://signin.immonet.de/?redirect_uri=",
    },
    googleOneTap: {
      googleClientId:
        "90381300939-be4a4l3tdrc1scmm24i35a1fa1d48t1c.apps.googleusercontent.com",
      auth0: {
        clientId: "ro2EtLY5U8dq5yO4sIr8oD1TpeLGNDOd",
        audience: brandName,
      },
      useGoogleOneTap,
    },
  },
};

export default createB2CBrand({
  id: "imn",
  name: brandName,
  defaultTitle: brandName,
  defaultDescription: brandName,
  theme: IMN_THEME,
  i18n: {
    supportedLanguageTags: ["de-DE"],
    defaultLanguageTag: "de-DE",
  },
  portal: "immonet.de",
  origin: origin[STAGE_LIKE_ENVIRONMENT],
  consentManagement: {
    id: consentID[STAGE_LIKE_ENVIRONMENT],
  },
  qualtrics: {
    id: "ZN_2czOCoufF8oMuvv",
    id_url: "QSI_S_ZN_2czOCoufF8oMuvv",
    url: "https://zn2czocouff8omuvv-avivgroup.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_2czOCoufF8oMuvv",
  },
  featureFlagging: {
    domain: getCookieDomain(
      origin,
      ENVIRONMENT,
      `immonet-${VERSION_EPHEMERAL}-b2c-shell.unified-emu-dev.aws.aviv.eu`,
      VERSION_EPHEMERAL,
    ),
    siteCode: "sqdhq8rbkk",
  },
  airship: {
    ...airshipConfig[STAGE_LIKE_ENVIRONMENT],
    trackingConsentId: "Q-WHSfBNSKFLnk",
    pushConsentId: "fNXJjp0bI3-vje",
  },
  appBanner: {
    adjust: {
      android: "v277zrnu66kr",
      ios: "y9v4824kbv22",
    },
  },
  errorEmailAddress: "produkt@immonet.de",
  authentication: authenticationConfig[STAGE_LIKE_ENVIRONMENT],
});
